import defaultAvatar from "../../assets/logo/logo.png";

export default function ProfileHeader({ user }) {
  return (
    <div className="profileHeader">
      <img
        src={user.profilPicture || defaultAvatar}
        className="profileAvatar"
        alt={user.firstName}
      />

      <div>
        <h1 className="profileName">
          {user.firstName} {user.lastName}
        </h1>
        <p className="profileRole">{user.role?.name}</p>
      </div>
    </div>
  );
}
